import React from "react";

export default function MobileCallButton() {
  const handlePhoneClick = () => {
    if (window.gtag) {
      window.gtag("config", "AW-18343552397", {
        phone_conversion_number: "1-877-991-0909",
      });
    }
  };

  return (
    <div className="fixed bottom-0 left-0 z-50 w-full bg-[#081c3a] p-3 lg:hidden border-t border-slate-700/50">
      <a
        href="tel:+18779910909"
        onClick={handlePhoneClick}
        className="mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded bg-[#e8211b] py-3 text-[15px] font-extrabold tracking-wide text-white transition-colors hover:bg-red-700 active:bg-red-800 shadow-md"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
          className="h-5 w-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-2.896-1.596-5.48-4.18-7.076-7.076l1.293-.97c.362-.271.527-.733.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
          />
        </svg>
        CALL NOW 1-877-991-0909
      </a>
    </div>
  );
}
